




























































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";
import {
  pagination,
  loadingCatch,
  loading,
  SearchbarControl,
  IsMore
} from "@root/lib/decorator";
import add from "./add.vue";
import role from "./role.vue";

const userManager = namespace("userManager");

@Component({ components: { add, role } })
@pagination("getData", {
  pageSize: 50
})
@SearchbarControl()
@loading()
@IsMore(true)
export default class userManagerPage extends Vue {
  @userManager.Action getDataList;
  @userManager.Action reSetOpUserAccountPassword;
  @userManager.Action deleteUserAccount;
  @userManager.State dataList;
  searchFormOptions: any = {
    form: [
      {
        label: "账号",
        key: "account",
        type: "input",
        value: ""
      }
      // {
      //   label: "手机号",
      //   key: "mobile",
      //   type: "input",
      //   value: ""
      // }
    ],
    loading: false
  };
  private form = {
    account: "",
    mobile: ""
  };
  loading: boolean = false;
  private total = 0;
  isEdit: boolean = false;
  editData: any = null;
  isLoginUser(d) {
    const userInfoStr = localStorage.getItem("userInfo"),
      userInfo = JSON.parse(userInfoStr || "{}"),
      { userCode } = userInfo;

    return userCode === d;
  }
  onFormDataChange(data) {
    this.form = { ...data };
  }
  isOaCooperation: any = '';
  async mounted() {
    this.isOaCooperation = localStorage.getItem("isOaCooperation");
    await this.getData();
  }

  @loadingCatch
  async getData() {
    const { pageSize, currentPage: pageNum }: any = this;
    try {
      this.loading = true;
      let { total } = await this.getDataList({
        condition: this.form,
        pageInput: {
          pageSize,
          pageNum
        }
      });
      this.total = total;
    } catch {
      //
    } finally {
      this.loading = false;
    }
  }
  //
  async handleDelete(data) {
    try {
      await this.$confirm("你确定要删除这个用户吗？");
      await this.deleteUserAccount({
        userCode: data.userCode
      });
      this.$message({ type: "success", message: "删除成功" });
      (this as any).currentPage = 1;
      this.getData();
    } catch (error) {
      console.log(error);
    }
  }
  handleAdd() {
    this.isEdit = false;
    this.editData = null;
    (this as any).$refs.add.dialogVisible = true;
  }
  handleEdit(data) {
    this.isEdit = true;
    (this as any).$refs.add.dialogVisible = true;
    this.editData = data;
  }
  handleEditRole(data) {
    (this as any).$refs.role.dialogVisible = true;
    this.editData = data;
  }
  async handleResetPassword(row) {
    try {
      await this.$confirm(
        "用户密码会被重置！新密码会发送至用户手机/邮箱。确认要继续吗？"
      );
      console.log(row);
      await this.reSetOpUserAccountPassword({
        userCode: row.userCode
      });

      this.$message({ type: "success", message: "发送成功" });
    } catch (error) {
      console.log(error);
    }
  }
  rolesString(row) {
    let list = (row.roleList || []).map(item => item.roleName).join(",");
    return list;
  }
  refresh(flag) {
    //1 是编辑 0 是新增
    if (flag === 1) {
      this.getData();
    } else {
      (this as any).currentPage = 1;
      this.getData();
    }
  }
}
